<div *ngFor="let entry of entries">
	<label>{{entry.value.title || entry.key }}</label>
	<workflow-schema-renderer [property]="entry.property" [schema]="entry.value" [data]="data" [required]="entry.required"></workflow-schema-renderer>
</div>
